import { Typography } from "@mui/material";
import { ReactNode } from "react";

// Shared label styling for the payroll row-action menu items.
const MenuItemLabel = ({ children }: { children: ReactNode }) => (
  <Typography color="#1D2939" fontSize="16px" textTransform="capitalize">
    {children}
  </Typography>
);

export default MenuItemLabel;
